/**** cat.DevMnt */
import { apiTypes } from 'shared/consts/handbooksApiTypes';

const config = {
  schema: 'cat',
  table: 'DevPasspotok',
  title: 'Устройства подсчёта пассажиров',
  apiType: apiTypes.DEFAULT,
  elemsOnPage: 100,
  connections: {
    vehicle: {
      apiType: apiTypes.DEFAULT,
      schema: 'mgt',
      table: 'Vehicle',
      index: 'vehicle_id',
      fields: ['depot_number'],
      format: (elem: any) => elem['depot_number'],
      autocomplete: true,
    }
  },
  fields: [
    {
      name: 'id',
      title: 'ID записи',
      index: true,
      type: 'number',
      width: '120px',
    },
    {
      name: 'name',
      title: 'Наименование',
      type: 'text',
      required: true
    },
    {
      name: 'enable',
      title: 'Состояние',
      type: 'list',
      required: false,
      values: [
        { key: null, value: '' },
        { key: 1, value: 'Включен' },
        { key: 0, value: 'Отключен' },
      ],
    },
    {
      name: 'protocol',
      title: 'Протокол',
      type: 'text',
      required: false
    },
    {
      name: 'door_index',
      title: 'Номер двери',
      type: 'number',
      required: false
    },
    {
      name: 'vehicle_id',
      title: 'Транспортное средство',
      type: 'number',
      required: true,
      connection: 'vehicle'
    },
    {
      name: 'transport',
      title: 'Передача данных',
      type: 'list',
      required: false,
      values: [
        { key: null, value: '' },
        { key: 'udp', value: 'UDP' },
        { key: 'can', value: 'CAN' },
      ],
    },
    {
      name: 'ip',
      title: 'IP-адрес',
      type: 'text',
      required: false,
      validate: (value: any) =>
        /\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}/.test(value),
      validateError: 'Неверный формат IP-адреса',
    },
    {
      name: 'port',
      title: 'Порт',
      type: 'number',
      required: false,
    },
    {
      name: 'addr',
      title: 'Адрес устройства',
      type: 'text',
      required: false,
    },
  ],
  newTemplate: {
    id: null,
    name: '',
    enable: null,
    protocol: null,
    door_index: null,
    vehicle_id: null,
    transport: null,
    ip: '',
    port: null,
    addr: ''
  },
  createField: 'createdAt',
  updateField: 'updatedAt',
  makeIdOnInsert: true,
  defaultSort: {
    field: 'id',
    direction: 'desc',
  },
  import: {
    header: [
      {
        title: 'pc_id',
        field: 'id',
      },
      {
        title: 'name',
        field: 'name',
      },
      {
        title: 'state',
        field: 'enable',
      },
      {
        title: 'protocol',
        field: 'protocol',
      },
      {
        title: 'door_num',
        field: 'door_index',
      },
      {
        title: 'ip',
        field: 'ip',
      },
      {
        title: 'port',
        field: 'port',
      },
      {
        title: 'adress',
        field: 'addr',
      },
      {
        title: 'data_transfer_type',
        field: 'transport',
      },
      {
        title: 'vehicle_id',
        field: 'vehicle_id',
      }
    ],
    example: `1;Название;0;nova;1;127.0.0.1;8080;адрес;tcp;1`,
  },
};

export default config;
